<div class="note-list-element" [class.disabled]="disabled">
  <p class="text">{{ note.text }}</p>

  <ul class="attached-files" [hidden]="!note.attachemntsName.length">
    @for (filename of note.attachemntsName; track filename) {
      <li>
        <app-file-label
          [disabled]="disabled"
          [hideDownloadBtn]="!canEdit"
          (downloadFile)="onDownloadFile(filename)"
          (deleteFile)="onDeleteFile(filename)"
        >
          {{ filename }}
        </app-file-label>
      </li>
    }
  </ul>

  <div class="note-footer">
    <div class="credentials">
      <div class="author">{{ note.user?.fullName }}</div>
      <div class="date">
        {{ note.modifiedOn | date: 'dd MMMM hh:mm a' }}
      </div>
    </div>

    <div class="controls" *appHasRole="['Admin', 'Manager', 'Preparer']">
      <app-ag-action-icon-button
        iconClass="ic-edit-16"
        [disabled]="disabled"
        (action)="onEditNote()"
      ></app-ag-action-icon-button>

      <app-ag-action-icon-button
        iconClass="ic-trash-16"
        [disabled]="disabled"
        (action)="onDeleteNote()"
      ></app-ag-action-icon-button>
    </div>
  </div>
</div>
